"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatorsFrom = validatorsFrom;

var _operators = require("rxjs/operators");

var _util = require("../util");

// Copyright 2017-2020 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0

/**
 * @description From a list of stashIds, staking ledgers for those acting as validators and those being nominated
 */
function validatorsFrom(instanceId, api) {
  return (0, _util.memo)(instanceId, stashIds => api.query.staking.nominators.multi(stashIds).pipe((0, _operators.switchMap)(optNoms => api.derive.staking.queryMulti(optNoms.reduce((validatorIds, optNom) => {
    return optNom.unwrapOrDefault().targets.reduce((validatorIds, targetId) => {
      if (!validatorIds.find(validatorId => validatorId.eq(targetId))) {
        validatorIds.push(targetId);
      }

      return validatorIds;
    }, validatorIds);
  }, [])))));
}